<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3 card-style">
          <div slot="header" class="row">
            <div class="col-6">
              <h4 class="card-title f-20-mobile">Campanhas</h4>
            </div>
            <div class="col-6 text-right">
              <router-link to="/notifications-list-new/create" class="btn btn-primary">+ Criar Nova Notificação</router-link>
            </div>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="title">Nome</th>
                <th class="text-center title">Tipo</th>
                <th class="text-center title">Alcance</th>
                <th class="text-center title">Abertas</th>
                <th class="text-center title">Envio</th>
                <th class="text-center title"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campaign of campaigns">
                <td>{{ campaign.campaign_name }}</td>
                <td align="center">{{ campaign.type }}</td>
                <td align="center">{{ campaign.campaign_range }}</td>
                <td align="center">{{ campaign.notifications_open }}</td>
                <td align="center">{{ campaign.campaign_date | moment("DD/MM/YYYY") }}</td>
                <td align="end" class="notification-expired" v-if="campaign.expired && campaign.expired == '1'">
                  <span>Notificação Expirada</span>
                </td>
                <td align="end" v-if="!campaign.expired || campaign.expired == '0'">
                  <router-link
                  :to="{ path: '/notifications-list-new/edit/' + campaign.campaign_id}"
                  class="btn btn-primary btn-edit-style">
                    Editar
                  </router-link>

                  <button @click="handleDeleteCampaign(campaign.campaign_id)"
                  class="btn btn-md btn-danger btn-trash-style">
                    <i class="fa fa-trash-o fa-5" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="!campaigns || !campaigns.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import { Card } from 'src/components'
import moment from 'moment'
import NotificationService from '@/services/NotificationService.js'

export default {
    components: {
      Card,
      moment,
    },
    data() {
      return {
        campaigns: [],
        total: 0,

        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{
      changePage(page) {
        this.current_page = page
        this.load()
      },

      filtrar() {
        this.load()
      },

      load() {
        NotificationService.load().then(res => {
          this.campaigns = res.data
          const campaignTypes = {
            SIMPLE_NOTIFICATION: 'Modal e Notificação',
            MODAL_AND_NOTIFICATION: 'Modal e Notificação (Modal Automático)',
            ONLY_MODAL_NOTIFICATION: 'Somente Modal Automático',
            ONLY_NOTIFICATION: 'Somente notificação',
            NPS: 'Pesquisa de NPS',
          }
          this.campaigns.map(campaign => {
            campaign.type = campaignTypes[campaign.type]
          })
        }).catch(err => {
          console.error(err)
        });
      },

      handleDeleteCampaign(idCampaign){
        this.$swal({
          title: "Atenção",
          html: "Tem certeza que deseja excluir esta campanha?</p>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#afafaf",
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            NotificationService.delete(idCampaign).then(res => {
              this.load()
              this.$swal({
                type: "success",
                title:"Sucesso!",
                text:"Campanha excluida!",
                timer: 3000
              })
            }).catch(err => {
              this.$swal({
                type: "error",
                title: "Ops... algo deu errado!",
                text: 'Verifique os campos preenchidos!',
                timer: 3000
              })
            });
          }
        });
      },

      getUnidade(unidade) {
        let unidades = [
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]
        return unidades[unidade];
      },
    },
    mounted() {
    setTimeout(() => {
      this.load()
    }, 400);
    },
}
</script>

<style lang='scss'>
.card-style {
  margin-top: 15px;
  height: 550px;
  overflow-y: auto;
}

.btn-edit-style {
  margin-right: 10px !important;
  font-size: 14px;
}

.btn-trash-style {
  margin-right: 15px !important;
  background-color: #FC5A5A;
  color: #FFFFFF;
  padding: 7.85px 12px;

  i {
    font-size: 24px;
  }
}

.notification-expired{
  color: #3C5373;
  font-weight:600 !important;

  span {
    margin-right: 15px !important;
  }
}

.title {
  color:#032351;
  font-weight:600 !important;
}

.text-center {
  text-align: center;
}
</style>
